import { AttachedProperty, Attribute } from '../../../concepts/objects';
import { Polyline } from '../../../platform/geom/Polyline';
import { Topic } from './Topic';

export const TopicAssocation = new AttachedProperty('topic', null);

export const TopicBoundaryAttr = new Attribute<Polyline, Topic>('boundary', null);
export const TopicSuspendedAttr = new Attribute<boolean, Topic>('suspended', null);
